import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/img/status-check-icon.png'


const _hoisted_1 = { class: "revise-content" }
const _hoisted_2 = { class: "revise-content__header header" }
const _hoisted_3 = { class: "header__title" }
const _hoisted_4 = { class: "header__description" }
const _hoisted_5 = { class: "revise-content__order-status order-status" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = {
  key: 0,
  class: "order-status__container--hover checked-container"
}
const _hoisted_8 = { class: "checked-container__text" }
const _hoisted_9 = { class: "revise-content__button-container button-container" }

import { i18n } from '@/i18n';
import { computed, ref, watch } from 'vue';
import Modal from '@/components/modal/Modal.vue';
import { OrderStatus } from '@/coreDomainsModule/entities/arrival';
import TextButton from '@/components/input/Btn/TextButton.vue';
import OrderStatusBadge from '@/corePagesModule/components/OrderStatusBadge.vue';
import { orderStatusDescriptions } from '@/corePagesModule/BaseTableContent/components/order/orderStatus';
import { isPartialDelivery } from '@/coreDomainsModule/entities/partialDelivery';
import { PartialDeliveryService } from '@/orderTableModule/domains/service/partialDeliveryService';
import { isOrder } from '@/coreDomainsModule/entities/order';
import { OrderService } from '@/orderTableModule/domains/service/orderService';
import { showInfoModal } from './InfoModal/InfoModalManager';

// props

export default /*@__PURE__*/_defineComponent({
  __name: 'OrderStatusReviseModal',
  props: {
    items: { default: undefined },
    modalState: { type: Boolean, default: false },
    headerTitle: { default: undefined },
    description: { default: undefined },
    isPartialDelivery: { type: Boolean, default: false },
    isBulkEdit: { type: Boolean, default: false }
  },
  emits: ["canceled", "confirm"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

// emits
const emits = __emit;

//変数
const t = i18n.t;
const selectedOrderStatus = ref<OrderStatus>();

watch(
  () => props.modalState,
  (newVal, oldVal) => {
    // false -> true になった場合、変数を初期化する
    if (oldVal === false && newVal === true) {
      selectedOrderStatus.value = undefined;
    }
  }
);

/**
 * 無効にするステータスかどうかを管理するためのcomputed
 */
const disabledStatusMap = computed(() => {
  const map = new Map<OrderStatus, boolean>();
  for (const status of orderStatusDescriptions) {
    map.set(status.status, isDisabledStatus(status.status));
  }
  return map;
});

/**
 * 無効にするステータスかどうか
 * @param status - ステータス
 */
const isDisabledStatus = (status: OrderStatus) => {
  if (props.items === undefined || props.items.length === 0)
    // ステータスが推奨か承認待ちの場合は無効
    return status === OrderStatus.Recommended || status === OrderStatus.ApprovalRequested;
  if (props.isPartialDelivery && props.items.some((item) => isPartialDelivery(props.items)))
    return props.items.some((item) => !PartialDeliveryService.canTransitionToStatus(item, status));
  if (props.items.some((item) => isOrder(item))) {
    // 一括編集の場合は、分納のステータスを無効にする
    if (props.isBulkEdit && status === OrderStatus.PartialDelivery) return true;
    return props.items.some((item) => !OrderService.canTransitionOrderStatus(item, status));
  }
  return false;
};

/**
 * ステータス適用
 */
const applyOrderStatus = async () => {
  // 分納から承認済みにする場合は、確認モーダルを表示
  if (
    props.items?.some((item) => isOrder(item)) &&
    props.items?.some((item) => item.orderStatus === OrderStatus.PartialDelivery) &&
    selectedOrderStatus.value === OrderStatus.ApprovedAwaitingDeliveryDate
  ) {
    const result = await showInfoModal({
      modalTitle: t('確認'),
      modalDescription: t('分納情報が削除されますが、よろしいですか？'),
      colorStyle: 'primary',
      nextButtonLabel: t('はい'),
      backButtonLabel: t('いいえ'),
    });
    if (!result) return;
  }

  emits('confirm', selectedOrderStatus.value as OrderStatus);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Modal, {
    class: "confirm-modal-container",
    "modal-size": 'max-content',
    "stretch-container": true,
    "scroll-off": true,
    padding: '16px',
    "modal-state": _ctx.modalState,
    "border-radius": '16px',
    onOutsideClick: _cache[0] || (_cache[0] = ($event: any) => (emits('canceled')))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(t)(_ctx.headerTitle ?? 'ステータスの一括修正')), 1),
          _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(t)(_ctx.description ?? 'チェックをつけた発注のステータスを一括修正することができます')), 1)
        ]),
        _createElementVNode("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(orderStatusDescriptions), (status, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: _normalizeClass(["order-status__container", { 'order-status__container--disabled': disabledStatusMap.value.get(status.status) }]),
              onClick: ($event: any) => (!disabledStatusMap.value.get(status.status) ? (selectedOrderStatus.value = status.status) : null)
            }, [
              _createVNode(OrderStatusBadge, {
                class: _normalizeClass([[selectedOrderStatus.value === status.status ? 'blur' : ''], "order-status__container--badge"]),
                "order-status-str": status.status
              }, null, 8, ["class", "order-status-str"]),
              _createElementVNode("span", {
                class: _normalizeClass([[selectedOrderStatus.value === status.status ? 'blur' : ''], "order-status__container--description"])
              }, _toDisplayString(_unref(t)(status.description)), 3),
              (selectedOrderStatus.value === status.status)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _cache[1] || (_cache[1] = _createElementVNode("img", {
                      class: "checked-container__image",
                      src: _imports_0
                    }, null, -1)),
                    _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(t)('選択する')), 1)
                  ]))
                : _createCommentVNode("", true)
            ], 10, _hoisted_6))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(TextButton, {
            "button-style": 'btn-cancel',
            size: 'btn-md',
            "on-click": () => emits('canceled'),
            class: "button-container--cancel-button"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('キャンセル')), 1)
            ], undefined, true),
            _: 1
          }, 8, ["on-click"]),
          _createVNode(TextButton, {
            "button-style": 'btn-primary',
            size: 'btn-md',
            disabled: !selectedOrderStatus.value,
            "on-click": applyOrderStatus,
            class: "button-container--confirm-button"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('適用')), 1)
            ], undefined, true),
            _: 1
          }, 8, ["disabled"])
        ])
      ])
    ], undefined, true),
    _: 1
  }, 8, ["modal-state"]))
}
}

})